import { render, staticRenderFns } from "./CommonVideoModal.vue?vue&type=template&id=2564062c&lang=pug&"
import script from "./CommonVideoModal.vue?vue&type=script&lang=js&"
export * from "./CommonVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports